module.exports = __webpack_public_path__ + "static/media/calendar.d4acc832.svg";